<ng-template cdkPortalOutlet></ng-template>
@if (!modalRef.config.centered) {
  <div class="arrow"></div>
}
